export default __webpack_public_path__ + "static/media/joinBg.c641d979.webp";